import { render, staticRenderFns } from "./TrainingHistory.vue?vue&type=template&id=512143af"
import script from "./TrainingHistory.vue?vue&type=script&lang=js"
export * from "./TrainingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports